import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuardService } from './auth/auth-guard.service';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./start/login/login.module').then(m => m.LoginModule)
  },
  // {
  //   path: 'login',
  //   loadChildren: () => import('./start/erp-login/erp-login.module').then(m => m.ErpLoginModule)
  // },
  {
    path: 'login-select-branch',
    loadChildren: () => import('./start/login-select-branch/login-select-branch.module').then(m => m.LoginSelectBranchModule)
  },
  {
    path: 'login-select-counter',
    loadChildren: () => import('./start/login-select-counter/login-select-counter.module').then(m => m.LoginSelectCounterModule)
  },
  // {
  //   path: 'login-select-fin-year',
  //   loadChildren: () => import('./start/erp-fin-year/erp-fin-year.module').then(m => m.ErpFinYearModule)
  // },
  {
    path: 'login-select-fin-year',
    loadChildren: () => import('./start/login-select-fin-year/login-select-fin-year.module').then(m => m.LoginSelectFinYearModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./start/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'login/reset/:id',
    loadChildren: () => import('./start/forgot-change-password/forgot-change-password.module').then(m => m.ForgotChangePasswordModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuardService],
    // canActivateChild: [AuthGuardService]
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  }
];

@NgModule({
  // imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
